import { Box } from '@chakra-ui/react'
import React from 'react'
import SharedHelpText from '~components/shared/form/shared-help-text'
import SharedLabel from '~components/shared/form/shared-label'
import SharedSwitch from '~components/shared/form/shared-switch'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { ChatFieldsFragment, ChatStatus } from '~graphql/generated/graphql'

interface Props {
    chat: ChatFieldsFragment
    shouldOpenChatOnSend: boolean
    setShouldOpenChatOnSend: (shouldOpenChatOnSend: boolean) => void
    shouldCloseChatOnSend: boolean
    setShouldCloseChatOnSend: (shouldCloseChatOnSend: boolean) => void
}

export default function ShouldUpdateChatStatus({
    chat,
    shouldOpenChatOnSend,
    setShouldOpenChatOnSend,
    shouldCloseChatOnSend,
    setShouldCloseChatOnSend,
}: Props) {
    const isChatClosed = chat.status === ChatStatus.Closed

    if (isChatClosed) {
        return (
            <SharedStack row>
                <Box flex={1}>
                    <SharedLabel>Open chats on send?</SharedLabel>
                    <SharedHelpText>
                        If this is checked at the time of sending, a closed chat
                        will be opened.
                    </SharedHelpText>
                </Box>
                <SharedSwitch
                    size="sm"
                    isChecked={shouldOpenChatOnSend}
                    onChange={e => setShouldOpenChatOnSend(e.target.checked)}
                />
            </SharedStack>
        )
    }

    return (
        <SharedStack row>
            <Box flex={1}>
                <SharedLabel>Close chats on send?</SharedLabel>
                <SharedHelpText>
                    If this is checked at the time of sending, a closed chat
                    will be opened.
                </SharedHelpText>
            </Box>
            <SharedSwitch
                size="sm"
                isChecked={shouldCloseChatOnSend}
                onChange={e => setShouldCloseChatOnSend(e.target.checked)}
            />
        </SharedStack>
    )
}
